/**
 * Tabbed Collections section: tab switching and Swiper update when panel is shown.
 * Scoped per section so multiple instances on the same page work independently.
 */

(function () {
  'use strict';

  const ARROW_KEYS = {
    ArrowRight: 1,
    ArrowDown: 1,
    ArrowLeft: -1,
    ArrowUp: -1
  };

  function initTabbedCollections(section) {
    if (!section || section.dataset.tabbedCollectionsInited) return;
    section.dataset.tabbedCollectionsInited = 'true';

    const tabs = section.querySelectorAll('[data-tabbed-collections-tab]');
    const panels = section.querySelectorAll('.tabbed-collections__panel');
    if (!tabs.length || !panels.length) return;

    function showPanel(panelId) {
      let activeTab = null;

      tabs.forEach(function (tab) {
        const isActive = tab.getAttribute('aria-controls') === panelId;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        if (isActive) activeTab = tab;
      });

      panels.forEach(function (panel) {
        panel.setAttribute('aria-hidden', panel.id !== panelId ? 'true' : 'false');
      });

      const activePanel = document.getElementById(panelId);
      if (activePanel) {
        const carouselEl = activePanel.querySelector('[js-carousel]');
        if (carouselEl && carouselEl.swiper) carouselEl.swiper.update();
      }

      const ctaLink = section.querySelector('[data-tabbed-collections-cta]');
      if (ctaLink && activeTab) {
        const url = activeTab.getAttribute('data-collection-url');
        ctaLink.href = url || '#';
      }
    }

    function handleTabClick(e) {
      const panelId = e.currentTarget.getAttribute('aria-controls');
      if (panelId) {
        showPanel(panelId);
      }
    }

    function handleKeydown(e) {
      const delta = ARROW_KEYS[e.key];
      if (delta === undefined) return;

      e.preventDefault();
      const tabArray = Array.from(tabs);
      const currentIdx = tabArray.findIndex(function (t) {
        return t.getAttribute('aria-selected') === 'true';
      });
      if (currentIdx === -1) return;

      const nextIdx = currentIdx + delta;
      if (nextIdx >= 0 && nextIdx < tabArray.length) {
        tabArray[nextIdx].click();
        tabArray[nextIdx].focus();
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', handleTabClick);
    });

    const tablist = section.querySelector('[role="tablist"]');
    if (tablist) {
      tablist.addEventListener('keydown', handleKeydown);
    }

    // Header prev/next control the active panel's carousel
    const prevBtn = section.querySelector('[data-tabbed-collections-prev]');
    const nextBtn = section.querySelector('[data-tabbed-collections-next]');

    function getActiveCarouselEl() {
      const activePanel = section.querySelector('.tabbed-collections__panel[aria-hidden="false"]');
      return activePanel ? activePanel.querySelector('[js-carousel]') : null;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        const carouselEl = getActiveCarouselEl();
        if (carouselEl && carouselEl.swiper) carouselEl.swiper.slidePrev();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        const carouselEl = getActiveCarouselEl();
        if (carouselEl && carouselEl.swiper) carouselEl.swiper.slideNext();
      });
    }
  }

  function initAll(container) {
    const root = container || document;
    root.querySelectorAll('[data-tabbed-collections]').forEach(initTabbedCollections);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    initAll();
  });
})();
